import { APP_KEY, HTTP_URL, PHP_API_URL } from '../../../util/constants'
import request from '../../../util/request'
import Cookies from 'js-cookie'


//获取用户列表
export function getPointsListRequest(type, offset, limit, callback) {
  let formData = new FormData()
  formData.append('appkey', APP_KEY)
  formData.append('caozuo', 'get_user_jifen_jilu')
  formData.append('type', type)
  formData.append('username', Cookies.get('username'));
  formData.append('offset', offset)
  formData.append('limit', limit)
  return request(
    PHP_API_URL + '/User/i',
    {
      method: 'POST',
      body: formData,
    },
    callback,
  )
}


export function getRechargeRecordListRequest( offset, limit, callback) {
  let formData = new FormData()
  formData.append('appkey', APP_KEY)
  formData.append('caozuo', 'get_goumai_jifen_list')
  formData.append('username', Cookies.get('username'));
  formData.append('offset', offset)
  formData.append('limit', limit)
  return request(
    PHP_API_URL + '/Chongzhi/i',
    {
      method: 'POST',
      body: formData,
    },
    callback,
  )
}